<div class="accordion">
  <flo-faq-question
    *ngFor="let data of faqData; trackBy: trackByFAQ"
    [question]="data.question"
  >
    <div answer [innerHtml]="data.answer | floSanitizeHtml"> </div>
  </flo-faq-question>
</div>
